import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { sessionAuthData } from '../interfaces/states-data';
import { getSessionAuthData } from '../states/session-auth/session-auth.selectors';

@Injectable({
  providedIn: 'root'
})
class PermissionService {
  constructor(
    private store: Store<{ sessionAuthState: sessionAuthData }>,
    private router: Router) { } // Asegúrate de inyectar tu servicio de autenticación y el router

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredPermission = route.data['requiredPermission'] as string;

    if (!requiredPermission) {
      return true;
    }

    return this.store.pipe(
      select(getSessionAuthData),
      take(1),
      map((sessionAuthState: sessionAuthData) => {
        const hasPermission = !!sessionAuthState.is_super_admin ||
          !!sessionAuthState.permissions?.includes(requiredPermission);

        if (hasPermission) {
          return true;
        }

        // UrlTree en vez de `navigate(...) + false`: con `false` el router cancela la
        // navegación y en un deep link (F5 / URL pegada) no hay ruta previa, así que la
        // URL sin permiso se quedaba en la barra con la vista vacía. Mismo criterio que
        // `permission-user-experience.guard.ts`.
        return this.router.parseUrl('/home');
      }),
    );
  }
 
}
 

export const PermissionUserGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const permissionService = inject(PermissionService);
  return permissionService.canActivate(next, state);
}

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => PermissionUserGuard(route, state);
